import { Box, Stack } from '@mui/material';
import {
  ChoiceControl,
  SectionCard,
  StatusBadge,
  designTokens,
  type StatusTone,
} from '../../../design-system';

export function IntegrationStatusCard({
  providerName,
  enabled,
  disabled,
  description,
  statusLabel = enabled ? '동기화 사용' : '동기화 중지',
  statusTone = enabled ? 'success' : 'neutral',
  onEnabledChange,
}: {
  providerName: string;
  enabled: boolean;
  disabled: boolean;
  description: string;
  statusLabel?: string;
  statusTone?: StatusTone;
  onEnabledChange?: (enabled: boolean) => void;
}) {
  return (
    <Box data-testid="integration-status-card">
      <SectionCard
        title="동기화 사용"
        help={<>{description} 변경하면 바로 저장되며 다음 동기화부터 적용됩니다.</>}
        headerPadding="standard"
        showDivider={false}
        action={(
          <Stack data-testid="integration-enabled-setting" direction="row" spacing={`${designTokens.space.xs}px`} sx={{ alignItems: 'center' }}>
            <StatusBadge label={statusLabel} tone={statusTone} />
            <ChoiceControl
              kind="switch"
              ariaLabel={`${providerName} 동기화 사용`}
              checked={enabled}
              disabled={disabled}
              onCheckedChange={onEnabledChange}
            />
          </Stack>
        )}
      >
        {null}
      </SectionCard>
    </Box>
  );
}
